"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAisleBalance = getAisleBalance;
async function getAisleBalance(machineRepo, aisleCode, machineId) {
    return await machineRepo.getAisleBalance(aisleCode, machineId);
}
